/*
 * @Author: DQL
 * @Date: 2020-03-05 17:12:52
 * @LastEditors: DQL
 * @LastEditTime: 2022-04-27 16:39:09
 * @Description: file content
 */
import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import config from './config'; // 系统配置文件
import router from './router.js'; // 主路由配置
import store from './store.js'; // 数据管理
import KestrelCoreUI, { HMAxiosInterceptor } from 'kestrel-core-ui'; // core-ui库
import 'kestrel-core-ui/lib/kestrel-core-ui.css'; // core-ui库样式
import 'kestrel-iconfont/lib/kestrel-iconfont.css'; // 图标库
import kestrelComponents from 'kestrel-components'; // 组件库

// 检测版本更新
import { getHash } from './uploadUtils';

import './style.scss';
import '@/banner.js';
// 自定义过滤器
import '@/filter';
import '@/features/components/component.js';
// 工作流通用组件
import '@/features/workflow/components/index.js';

// 模拟服务
// import '@/mock/index.js';
// import '@/mock/workflow/index.js';

// .finally is not a function —— 解决低版本浏览器axios不支持finally
// 参考：https://segmentfault.com/a/1190000015550213
require('promise.prototype.finally').shim();

Vue.config.productionTip = false;

// 应用ui库
Vue.use(KestrelCoreUI, {
  size: 'mini'
});

Vue.use(kestrelComponents);

// 调用ui库方法，配置请求拦截器
HMAxiosInterceptor(axios, router, {
  serverHeaderTokenName: config.serverHeaderTokenName,
  localTokenName: config.localTokenName
});

// 挂在axios
Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  data () {
    return {
      timer: null,
      checkVersionIntervalTime: config.checkVersionIntervalTime, // 定点检测
      isAutoRefreshVersion: config.isAutoRefreshVersion,
      oldCheckTime: null,
      nextCheckTime: null,
      nextCheckTimeIndex: null,
      env: process.env.NODE_ENV
    };
  },
  created () {
    if (this.checkVersionIntervalTime.length <= 0) return;
    if (this.env === 'production') {
      getHash(this.$alert, this.isAutoRefreshVersion);
    }
  },
  mounted () {
    if (this.checkVersionIntervalTime.length <= 0) return;
    if (this.env === 'production') {
      const _this = this;
      this.timer = setInterval(() => {
        const now = new Date();
        const _CheckTimeH = now.getHours() < 9 ? ('0' + now.getHours()) : now.getHours();
        const _CheckTimeS = now.getMinutes() < 9 ? ('0' + now.getMinutes()) : now.getMinutes();
        if (_this.oldCheckTime !== `${_CheckTimeH}:${_CheckTimeS}` && _this.checkVersionIntervalTime.includes(`${_CheckTimeH}:${_CheckTimeS}`)) {
          console.log('检测是否有新版本：', `${_CheckTimeH}:${_CheckTimeS}`);
          _this.oldCheckTime = `${_CheckTimeH}:${_CheckTimeS}`;
          getHash(_this.$alert, _this.isAutoRefreshVersion);
        }
      }, 2 * 1000);
    }
  },
  destroyed () {
    this.timer = null;
  },
  render: h => h(App)
}).$mount('#app');
